"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressBar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const react_jss_1 = __importDefault(require("react-jss"));
const progressBar_style_1 = __importDefault(require("./progressBar.style"));
const ProgressBar = ({ classes, completed, step = 'uploading' }) => (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root, "data-cy": "forms-js-progress-bar" }, { children: [jsx_runtime_1.jsx("div", Object.assign({ className: classes.fullBar }, { children: jsx_runtime_1.jsx("div", { className: classes.dynamicBar }, void 0) }), void 0),
        jsx_runtime_1.jsxs("div", Object.assign({ className: classes.labelWrapper }, { children: [jsx_runtime_1.jsxs("div", Object.assign({ className: classes.progressWrapper }, { children: [jsx_runtime_1.jsx("span", { children: String(completed) }, void 0),
                        jsx_runtime_1.jsx("span", { children: "%" }, void 0)] }), void 0),
                jsx_runtime_1.jsxs("span", { children: ["(", step, "...)"] }, void 0)] }), void 0)] }), void 0));
exports.ProgressBar = ProgressBar;
exports.ProgressBar.defaultProps = {
    completed: undefined,
    step: undefined
};
exports.default = react_jss_1.default(progressBar_style_1.default)(react_1.default.memo(exports.ProgressBar));
//# sourceMappingURL=index.js.map